<template>
    <div class="w-100 row">
      <div :class="[horizontal ? 'col-12' : 'col-4 col-sm-12 mb-1']" v-if="!hiddenControls">
        <div class="row">
          <button
              v-for="tab in tabs"
              :key="tab.name"
              @click="$emit('update:modelValue', tab.name)"
              :class="['tab-button', horizontal ? 'col' : 'col-12 col-sm-6', { active: modelValue === tab.name }]"
          >
              {{ tab.label }} <i v-if="!!tab.icon" :class="tab.icon"></i>
          </button>
        </div>
      </div>
      <div :class="[horizontal ? 'col-12' : 'col-4 col-sm-12']">
          <div v-for="(tab, index) in tabs" :key="`${tab.name}-${index}`" :class="['tab w-100', {'pl-1': !horizontal}]">
            <div class="w-100" v-show="tab.name === modelValue">
              <slot :name="tab.name"></slot>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,
            required: true
        },
        tabs: {
            type: Array,
            default: [] 
        },
        horizontal: {
          type: Boolean,
          default: false
        },
        hiddenControls: {
          type: Boolean,
          default: false
        }
    }
}

</script>


<style scoped>
.tabs-container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.tabs {
  display: flex;
  gap: 10px;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}

.tab-button {
  padding: 10px 15px;
  border: none;
  background: #f8f8f8;
  cursor: pointer;
  transition: 0.3s;
  /* font-weight: bold; */
  color: #555;
  font-size: 1.1rem; /* Aumenta ligeramente el tamaño del texto */
  text-transform: uppercase;
}

.tab-button:hover {
  background: #e0e0e0;
}

.tab-button.active {
  /* border-right: 3px solid var(--primary-color);; */
  color: var(--primary-color);
  border-bottom: 3px solid var(--primary-color);
}

.tab-content {
  padding: 20px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 0 0 8px 8px;
}
</style>